import WizardHeader from "../../components/WizardHeader"
import WizardFooter from "../../components/WizardFooter"
import LiabilityInsuranceCoverageCard from "./LiabilityInsuranceCoverageCard"

export interface LiabilityInsuranceCoverageProps {
  handleNext: () => void
}

const LiabilityInsuranceCoverage = ({
  handleNext,
}: LiabilityInsuranceCoverageProps) => (
  <div
    className="pt-10 lg:pt-13 pb-31"
    data-testid="liability-insurance-coverage"
  >
    <WizardHeader
      eyebrow="Your NCX Guide"
      heading="Liability Insurance Coverage"
      subheading="Protect yourself from liability claims with comprehensive coverage designed specifically for landowners."
      text="NCX offers a comprehensive general liability policy option through our partnership with Outdoor Underwriters*."
    />

    <div className="container grid grid-cols-1 w-[752px] max-w-full gap-6 px-5 lg:px-10 mt-10 mx-auto">
      <LiabilityInsuranceCoverageCard
        eyebrow="Insurance Coverage"
        heading="Comprehensive General Liability"
        subheading="Essential protection for all landowners"
        list={[
          "Limit of Liability: $1,000,000 Each Occurrence, $2,000,000 Aggregate",
          "Deductible: $250 per occurrence",
          "Covers injuries to visitors on your property",
          "Protection from property damage claims",
          "Legal defense coverage included",
          "Comprehensive coverage for wide range of activities excluding hunting",
        ]}
        price="0.32"
        minPremium="225"
      />
    </div>

    <p
      className="text-charcoal-500 text-xs text-center font-body leading-[140%] tracking-[0.36px] mt-12"
      data-testid="disclaimer"
    >
      *Outdoor Underwriters acts as the insurance agency placing all coverage
      with the carrier Lloyds of London.
    </p>

    <WizardFooter>
      <div className="flex gap-4 ml-auto">
        <button
          type="button"
          className="liability-insurance-coverage-get-started btn2 btn2-primary font-bold tracking-[0.32px] whitespace-nowrap"
          onClick={handleNext}
          data-testid="get-started-button"
        >
          Get Started
        </button>
      </div>
    </WizardFooter>
  </div>
)

export default LiabilityInsuranceCoverage
